(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("_"));
	else if(typeof define === 'function' && define.amd)
		define("wixstores", ["_"], factory);
	else if(typeof exports === 'object')
		exports["wixstores"] = factory(require("_"));
	else
		root["wixstores"] = factory(root["_"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__9479__) {
return 